// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hCUyu{display:flex;flex-direction:column;gap:16px;width:100%;max-width:520px;margin:0 auto}.HlH7x{display:flex;align-items:center;gap:12px;margin:4px 0}.rNDan{flex:1;height:1px;background-color:rgba(0,0,0,.08)}.vV9vh{flex:0 0 auto;color:rgba(0,0,0,.6);text-transform:uppercase;letter-spacing:.05em}.lfvDs{display:flex;flex-direction:row;justify-content:center;gap:12px}.lfvDs.ZqeuE{flex-direction:column;align-items:stretch}.HePMS{display:flex;justify-content:center}.ZqeuE .HePMS{width:100%}.YnXMv{display:flex;justify-content:center}.YnXMv>*{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `hCUyu`,
	"divider": `HlH7x`,
	"dividerLine": `rNDan`,
	"dividerLabel": `vV9vh`,
	"oauthRow": `lfvDs`,
	"mobile": `ZqeuE`,
	"oauthCell": `HePMS`,
	"intuitContainer": `YnXMv`
};
export default ___CSS_LOADER_EXPORT___;
